<div style="width: 10%">
  <div class="text-muted small mb-1">{{'pages.lookup.result.risk' | translate }}</div>
  <div class="text-uppercase"><span [ngClass]="'bg-' + riskClass(factor)" class="badge">{{('pages.lookup.result.risk.' + factor.risk | translate)}}</span></div>
</div>

<div style="width: 20%">
  <div class="text-muted small mb-1">{{'pages.lookup.result.rule' | translate }}</div>
  <div class="text-truncate-custom fw-semibold">{{factor.name}}</div>
</div>

<div style="width: 20%">
  <div class="text-muted small mb-1">{{'pages.lookup.result.report' | translate }}</div>
  <div class="justify-content-around">
    <button type="button" class="btn btn-link fs-5 fw-bolder text-action-2 p-0">
      {{factor.report}}
    </button>
  </div>
</div>

<div style="width: 40%">
  <div class="text-muted small mb-1">{{'pages.lookup.result.description' | translate }}</div>
  <div class="text-truncate-custom fw-semibold">{{factor.description}}</div>
</div>

<div style="width: 10%">
  <div class="text-muted small mb-1">{{'pages.lookup.result.score' | translate }}</div>
  <div class="fw-bold"><span [ngClass]="'text-' + riskClass(factor)">{{factor.result?.toFixed(1)}}</span></div>
</div>
